import React, {useEffect, useState, useRef} from 'react';

import {useNavigation, useNavigate} from "react-router-dom";

// import ClickAwayListener from '@mui/material/ClickAwayListener';

import Fab from '@mui/material/Fab';
import CloseIcon from '@mui/icons-material/Close';
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
// import DifferenceOutlinedIcon from '@mui/icons-material/DifferenceOutlined';
// import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import EditNoteIcon from '@mui/icons-material/EditNote';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import Slide from '@mui/material/Slide';

import {isAdmin, isAuthor} from 'ultra/helpers/auth';
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity} from 'ultra/configs/general';
import {hasFullAccess} from 'ultra/helpers/auth';

import ShareButton from '../../Buttons/ShareButton'
import CorrectNodeButton from '../../Buttons/CorrectNodeButton'
import UpdateNodeButton from '../../Buttons/UpdateNodeButton'
import RemoveNodeButton from '../../Buttons/RemoveNodeButton'
import ValidateNodeButton from '../../Buttons/ValidateNodeButton'
import AddNodeButton from '../../Buttons/AddNodeButton'

import {useNavigationStore} from '../../../../../../Stores/navigation';

import {useGlobalCustomContext} from '../../../../../../Helpers/context';
import {getTelegramUser} from '../../../../../../Helpers/telegram';

import AdaptiveDialog from '../../../../../../Components/Adaptive/Dialog';

import UserProfileLink from '../../../UserProfileLink';

import './index.scss';

function Actions(props) {
    const {config, content, onCloseAction, showAdd} = props;

    const [showInfo, setShowInfo] = useState(false);

    const {userState} = useGlobalCustomContext();

    const navigate = useNavigate();

    const createNodes = config.permits.children.create;
    const createIdentifiedNodes = config.permits.identified.children.create;

    const {contentLoading} = useNavigationStore()
    const ableToUpdate = config.permits.update;
    const ableToDelete = config.permits.delete;
    const ableToValidate = config.permits.validate
    const ableToCorrect = !ableToUpdate && config.form.availableToCorrect;
    const ableViewHistory = hasFullAccess(userState?.user);
    
    const handleInfoOpen = () => {
        setShowInfo(true);
    }

    const handleInfoClose = () => {
        setShowInfo(false);
    }

    const handleHistoryClick = () => {
        const city = getClientCity(window) || DEFAULT_CITY;
        navigate(`/profile/history/node/${city}/${config.page.content._did}`)
    }

    return <>
        <Fab
            color="neutral"
            onClick={handleInfoOpen}>
                <InfoOutlineIcon />
        </Fab>

        {/* <ShareButton did={config.page.content._did} title={config.page.content.title} color="neutral" /> */}

        <AdaptiveDialog
            open={showInfo}
            onClose={handleInfoClose}
            title={"Інформація"}
        >
            <AdminNodeInfo content={config?.page?.content} stat={config?.page?.stat}/>
        </AdaptiveDialog>

        {ableViewHistory && <Fab
            color="neutral"
            onClick={handleHistoryClick}>
                <HistoryOutlinedIcon />
        </Fab>}

        {ableToValidate && <ValidateNodeButton disabled={contentLoading} published={content._published} uri={config?.page?.content._uri} />}

        {ableToDelete && <RemoveNodeButton disabled={contentLoading} uri={config?.page?.content._uri}/>}

        {ableToUpdate && <UpdateNodeButton type={config?.page?.content._type} uri={config?.page?.content._uri} closeAction={onCloseAction}/>}

        {!ableToUpdate && ableToCorrect && <CorrectNodeButton disabled={contentLoading} />}

        {/* {showAdd && <AddNodeButton
            closeAction={onCloseAction}
            parent={config?.page?.content._uri}
            nodes={createNodes}
            identifiedNodes={createIdentifiedNodes}
            childrenOptions={config.page?.config?.childrenOptions}
        />} */}
    </>
}

export default function NodeButton(props) {
    const {config} = props;
    // onOpen

    const navigation = useNavigation();

    const [showActions, setShowActions] = useState(false);

    const ableToUpdate = config.permits.update;
    const ableToDelete = config.permits.delete;
    const ableToValidate = config.permits.validate

    let availableButtons = 0    
    if (ableToUpdate) availableButtons++
    if (ableToDelete) availableButtons++
    if (ableToValidate) availableButtons++

    useEffect(() => {
        if (navigation.state === 'loading') {
            setShowActions(false);
            close();
        }
    }, [navigation])

    function open() {
        // onOpen(true);
        setShowActions(true);
    }

    function close() {
        // onOpen(false);
        setShowActions(false);
    }

    function showItToggle() {
        showActions ? close() : open()
    }

    if (availableButtons === 0) return <></>

    if (availableButtons === 1) return <Actions {...props} onCloseAction={close}/>

    return <div className='NodeManipulationsButton'>
        <Slide direction="up" in={showActions} mountOnEnter unmountOnExit>
            <div className='NodeActions'>
                <Actions {...props} onCloseAction={showItToggle}/>
            </div>
        </Slide>

        {/* <ClickAwayListener onClickAway={() => showActions ? close() : open()}> */}
        <Fab color="contrast" className={'NodeActionsButton' + (showActions ? ' Close' : '')} onClick={showItToggle}>
            {showActions ? <CloseIcon /> : <EditNoteIcon /> }
        </Fab>
        {/* </ClickAwayListener> */}

        {/* {showActions && <span className='transparentBack' onClick={close}></span>} */}
    </div>
}

function AdminNodeInfo(props) {
    const {content, stat} = props;

    const {userState} = useGlobalCustomContext();

    const [telegram] = useState(getTelegramUser());

    const city = getClientCity(window) || DEFAULT_CITY;

    if (!isAdmin(userState?.user)) {
        return <></>
    }

    return <div className='AdminNodeInfo'>
        {content._did && <div className='labelWrap'>
            <span className="label">DID:</span>
            <span className='labelValue'>
                {content._did}
            </span>
        </div>}
        {content.originalDid && <div className='labelWrap'>
            <span className="label">Alias:</span>
            <span className='labelValue'>
                <a href={`?goToDid=${content.city}:${content.did}`} target='_blank'>{content.did}</a>
            </span>
        </div>}
        {content._type === "event" && (isAdmin(userState?.user) || isAuthor(content, userState?.user, telegram)) && <div className='labelWrap labelWrapRow'>
            <span className="label">Реєстрація через Телеграм:</span>
            <span className='labelValue'>
                <a href={`https://t.me/MiyProstirBot?start=event-reg-${city}-${content._did}`}>https://t.me/MiyProstirBot?start=event-reg-{city}-{content._did}</a>
            </span>
        </div>}
        {<div className='labelWrap labelWrapRow'>
            <span className="label">Посилання в боті:</span>
            <span className='labelValue'>
                <a href={`https://t.me/MiyProstirBot/bali?startapp=goToDid---${city}___${content._did}`}>https://t.me/MiyProstirBot/bali?startapp=goToDid---${city}___${content._did}</a>
            </span>
        </div>}
        {content._created_by && <div className='labelWrap labelWrapRow'>
            <span className="label">Created:</span>
            <span className='labelValue'>
                <UserProfileLink id={content._created_by} />
            </span>
        </div>}
        {stat?.views && <div className='labelWrap'>
            <span className="label">Перегляди:</span>
            <span className='labelValue'>
                {stat.views}
            </span>
        </div>}
    </div>
}
